import React, { useContext, useState } from "react";
import { RicosContext } from "./../../ricos-context";
import {
  getIsModalOpen,
  useModalService,
  useModalState
} from "./../../ricos-modals/modal-service-provider";
import { EditIcon, ToggleButton } from "./../../toolbars-ui";
import { FLOATING_PLUGIN_TOOLBAR } from "./../../toolbars-v3";
import { InsertModal } from "./insert-modal/InsertModal";
const EditHtmlButton = ({ toolbarItem, dataHook, id }) => {
  const [referenceElement, setReferenceElement] = useState(null);
  const { t, isMobile } = useContext(RicosContext) || {};
  const modalService = useModalService();
  const isModalOpen = useModalState(getIsModalOpen(id));
  const onClick = () => {
    const componentProps = {
      nodeId: toolbarItem.attributes.selectedNode.attrs.id,
      closeModal: () => modalService.closeModal(id)
    };
    const isModalOpen2 = modalService.isModalOpen(id);
    isModalOpen2 ? modalService.closeModal(id) : modalService.openModal({
      Component: InsertModal,
      id,
      componentProps,
      layout: isMobile ? "fullscreen" : "floating",
      positioning: {
        referenceElement: referenceElement?.closest(`[data-hook~=${FLOATING_PLUGIN_TOOLBAR}]`) ?? referenceElement,
        placement: "right-start"
      },
      withTransition: true,
      noPadding: true,
      type: "exclusive",
      enableDrag: !isMobile,
      dragHandleSelector: "[data-drag-handler]"
    });
  };
  return /* @__PURE__ */ React.createElement(
    ToggleButton,
    {
      active: isModalOpen,
      dataHook,
      Icon: EditIcon,
      label: t("HtmlPlugin_EditHtml_Tooltip"),
      tooltip: t("HtmlPlugin_EditHtml_Tooltip"),
      onClick,
      setRef: setReferenceElement
    }
  );
};
export {
  EditHtmlButton
};
//# sourceMappingURL=EditHtmlButton.js.map
